import { Autocomplete, ListItemIcon, ListItemText, MenuItem, TextField } from '@mui/material'
import { CustomerFilters } from './AssignBundles'
import { CheckBox, CheckBoxOutlineBlank } from '@mui/icons-material'
import { AutoCompleteOptions } from '../../../../hooks/useLookupTables'

type Props = {
  customerFilters: CustomerFilters
  setCustomerFilters: React.Dispatch<React.SetStateAction<CustomerFilters>>
  statusOptions: AutoCompleteOptions[]
}

export default function AssignBundlesFilters({ customerFilters, setCustomerFilters, statusOptions }: Props) {
  return <>
    <MenuItem>
      <Autocomplete
        id='bundles-filter-affiliation'
        options={statusOptions}
        renderInput={(params) => <TextField {...params} label='Statuses' />}
        value={customerFilters.statuses}
        onChange={(event, newValue) => setCustomerFilters((prev) => ({ ...prev, statuses: newValue }))}
        multiple
        disableCloseOnSelect
        fullWidth
      />
    </MenuItem>

    <MenuItem onClick={() => setCustomerFilters((filters) => ({ ...filters, hideWithBundle: !filters.hideWithBundle }))}>
      <ListItemIcon>
        {customerFilters.hideWithBundle ? <CheckBox /> : <CheckBoxOutlineBlank />}
      </ListItemIcon>
      <ListItemText>
        Hide students with selected bundle
      </ListItemText>
    </MenuItem>

    <MenuItem onClick={() => setCustomerFilters((filters) => ({ ...filters, hideAssignedEqualExpected: !filters.hideAssignedEqualExpected }))}>
      <ListItemIcon>
        {customerFilters.hideAssignedEqualExpected ? <CheckBox /> : <CheckBoxOutlineBlank />}
      </ListItemIcon>
      <ListItemText>
        Hide assigned = expected
      </ListItemText>
    </MenuItem>
  </>
}
